export enum CustomPanelType {
  ModifyColumns,
  None,
}